/**
 * The admin's exports as Excel or CSV (15.10.2026): the same link, with
 * `format=xlsx` for Excel. Excel comes first — it opens right anywhere with
 * a double click; CSV stays for importing elsewhere.
 */
export const EXPORT_FORMATS = [
  { key: "xlsx", label: "Excel (.xlsx)" },
  { key: "csv", label: "CSV" },
];

/** `/admin/leads/export` + the list's filters + the format. */
export function exportPath(path, params, format) {
  const qs = new URLSearchParams(params || "");
  qs.delete("format");
  if (format === "xlsx") qs.set("format", "xlsx");
  const query = qs.toString();
  return query ? `${path}${path.includes("?") ? "&" : "?"}${query}` : path;
}

/** "inscrieri" → "inscrieri.xlsx". */
export const exportName = (stem, format) => `${stem}.${format === "xlsx" ? "xlsx" : "csv"}`;
